<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="login-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h3 class="h3 mb-4">Forgot Password</h3>
      <ForgotPasswordForm />
    </div>
  </b-container>
</template>

<script>
import ForgotPasswordForm from '../../components/Forms/ForgotPasswordForm'

export default {
  name: 'AdminForgotPassword',
  components: { ForgotPasswordForm }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/AdminForgotPassword.vue?757cd34e